import type { SVGProps } from "react";
const SvgCommunityPostTypeDiscussion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 15 15"
    fontSize="1rem"
    {...props}
  >
    <path
      fill="#B1A2EA"
      d="M6.668 6.034a.396.396 0 0 0 .405-.385.396.396 0 0 0-.405-.386.396.396 0 0 0-.406.386c0 .212.182.385.406.385M9.045 6.034a.396.396 0 0 0 .405-.385.396.396 0 0 0-.405-.386.396.396 0 0 0-.406.386c0 .212.182.385.406.385"
    />
    <path
      fill="#B1A2EA"
      d="M12.694 7.79c.336-.27.61-.605.8-.983s.295-.79.306-1.21c0-1.932-2.192-3.422-4.756-3.422-2.142 0-3.954 1.02-4.546 2.423a2.6 2.6 0 0 0-.207 1c0 1.888 2.128 3.422 4.753 3.422.492 0 .981-.055 1.458-.165q.066-.014.131-.031c.113-.03.818.76 2.651.993a.1.1 0 0 0 .055-.009.1.1 0 0 0 .04-.037.09.09 0 0 0-.008-.101c-.61-.695-.865-1.719-.677-1.88M6.668 6.48a.9.9 0 0 1-.486-.14.84.84 0 0 1-.322-.374.8.8 0 0 1-.05-.48.8.8 0 0 1 .24-.425.9.9 0 0 1 .447-.227.9.9 0 0 1 .505.047c.16.063.297.17.393.306a.8.8 0 0 1-.11 1.049.9.9 0 0 1-.617.243m2.377 0a.9.9 0 0 1-.486-.14.84.84 0 0 1-.322-.374.8.8 0 0 1-.05-.48.8.8 0 0 1 .24-.425.9.9 0 0 1 .447-.227.9.9 0 0 1 .505.047c.16.063.297.17.393.306a.8.8 0 0 1-.11 1.049.9.9 0 0 1-.617.243m2.377 0a.9.9 0 0 1-.486-.14.84.84 0 0 1-.322-.374.8.8 0 0 1-.05-.48.8.8 0 0 1 .24-.425.9.9 0 0 1 .447-.227.9.9 0 0 1 .505.047c.16.063.297.17.393.306a.8.8 0 0 1-.11 1.049.9.9 0 0 1-.617.243"
    />
    <path
      fill="#B1A2EA"
      d="M11.422 6.034a.396.396 0 0 0 .405-.385.396.396 0 0 0-.405-.386.396.396 0 0 0-.406.386c0 .212.182.385.406.385M9.044 9.465q.594 0 1.177-.1c-.773 1.133-2.393 1.912-4.266 1.912a6.4 6.4 0 0 1-1.589-.195c-.112-.03-.818.761-2.65.993a.1.1 0 0 1-.055-.009.1.1 0 0 1-.04-.036.09.09 0 0 1 .008-.1c.61-.695.865-1.721.677-1.881a3 3 0 0 1-.8-.985A2.85 2.85 0 0 1 1.2 7.855c.002-1.396 1.146-2.562 2.75-3.101a2.8 2.8 0 0 0-.127.844c0 2.13 2.341 3.867 5.221 3.867"
    />
  </svg>
);
export default SvgCommunityPostTypeDiscussion;
